export type IGetFieldIdForIdentifier = (identifier: string, suffix?: '') => number;

export function getFieldIdForIdentifier(identifier: string, suffix = ''): number {
  let id = 0;
  for (const field of (window as any)[`fields${suffix}`]) {
    if (String(field.identifier) === String(identifier)) {
      id = field.id;
      break;
    }
  }
  return id;
}
